var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysReset = function SvgSysReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.909 12.421a6.415 6.415 0 0 1-1.643-2.383.498.498 0 0 1 .09-.56.498.498 0 0 1 .72-.002.501.501 0 0 1 .108.168c.305.775.784 1.47 1.4 2.03a5 5 0 1 0-.3-6.99L4 4.998h1.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0V4.61l.538-.6a5.897 5.897 0 0 1 8.391-.502 5.895 5.895 0 0 1 .377 8.396 6.032 6.032 0 0 1-4.489 2.006 5.819 5.819 0 0 1-3.908-1.488Z"
  })));
};
export default SvgSysReset;